import 'cookie-store'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App'

import './app.css'

// Loki.build is paused: no Sentry / Mixpanel init — the shutdown notice renders
// on its own with no background requests.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
